import React, {Fragment, useEffect} from "react";
import dataJson from "../config/signUp-verify.json";
import GenericForm from "../genericForm"
import {email_signup_} from "../../actions/axios-api";

export default function SendEmail({body, setLoading}) {
  useEffect(async () => {
    window.analytics.page('PAGEVIEW_SIGNUP_STARTED', {
      page: 'WC_Signup_success',
      journey: 'WC_Onboarding',
      product_group: 'Lending',
      product_name: 'Working_Capital',
    });
  }, []);
  const handleSubmit = async () => {
    setLoading(true);
    window.analytics.track('SIGNUP_RESEND', {
      page: 'Signup_WC_success',
      journey: 'WC_Onboarding',
      button_name: 'Reenviar',
      product_group: 'Lending',
      product_name: 'Working_Capital',
    });
    await email_signup_(body)
    setLoading(false); 
  };

  return (
      <Fragment>
        <GenericForm
            form={dataJson.forms}
            initialValue={{}}
            validates={""}
            onSubmit={handleSubmit}
            isDefault={true}
        />
      </Fragment>
  );
}
